import React, {useEffect} from 'react'

import {motion, useAnimation} from 'framer-motion'

import {logEvent} from '@lib/gtm'
import {AninationPropsT} from '@types'

import {IconArrowRight, IconVector} from '@components/Icon'

type AboutProps = {
  animation: (delay?: number) => AninationPropsT
  scrollTo: (e: React.MouseEvent<HTMLAnchorElement>) => void
}
export const About = ({animation, scrollTo}: AboutProps) => {
  const controls = useAnimation()
  useEffect(() => {
    const element = document.querySelector('.CustomAI__about')
    const onScroll = () => {
      const elementTop = element.getBoundingClientRect().top
      const windowHeight = window.innerHeight

      if (elementTop < windowHeight * 0.75) {
        controls.start({opacity: 1, y: 0})
      } else {
        controls.start({opacity: 0, y: 50})
      }
    }

    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [controls])
  return (
    <motion.div
      className='CustomAI__about'
      initial={{opacity: 0, y: 10}}
      animate={controls}
      transition={{duration: 0.1}}
    >
      <div className='CustomAI__about__bg'>
        <img
          className='bg-1'
          src='/images/custom-ai/bg-small.svg'
          alt='custom-ai'
        />
        <img
          className='bg-2'
          src='/images/custom-ai/bg-big.svg'
          alt='custom-ai'
        />
      </div>
      <div className='CustomAI__about__container'>
        <div className='CustomAI__about__container__quote'>
          <IconVector />
          <hr className='line' />
        </div>
        <div className='CustomAI__about__container__content'>
          <div className='content-1'>
            <picture className='content-1__image'>
              <source
                srcSet='/images/custom-ai/ai-about1.webp'
                type='image/webp'
              />
              <source
                srcSet='/images/custom-ai/ai-about1.png, /images/custom-ai/ai-about1@2x.png'
                type='image/png'
              />
              <img
                src='/images/custom-ai/ai-about1@2x.png'
                alt='Custom AI'
                loading='lazy'
                width='200'
              />
            </picture>
            <h2 className='content-1__content--desktop'>
              ปัจจุบันโลกกำลังเดินไปข้างหน้าอย่างรวดเร็วพร้อมกับ
              <br />
              <span>การแข่งขันที่สูงขึ้น</span> ทำให้ธุรกิจต่างๆ
              ต้องปรับตัวและคำนึงถึงยอดขาย <br />
              รวมถึงการทำงานที่มีประสิทธิภาพและประหยัดเวลา ทำให้ธุรกิจต่างๆ{' '}
              <br />
              <span>นำเทคโนโลยีรวมถึง AI มาใช้ประโยชน์</span>
            </h2>
            <h2 className='content-1__content--mobile'>
              ปัจจุบันโลกกำลังเดินไปข้างหน้าอย่างรวดเร็ว <br />
              พร้อมกับ
              <span>การแข่งขันที่สูงขึ้น</span> ทำให้ธุรกิจต่างๆ
              <br />
              ต้องปรับตัวและคำนึงถึงยอดขาย รวมถึงการทำงาน
              <br className='content-1__content--mobile__lineBreak' />
              ที่มีประสิทธิภาพและประหยัดเวลา ทำให้ธุรกิจต่างๆ
              <br className='content-1__content--mobile__lineBreak' />
              <span>นำเทคโนโลยีรวมถึง AI มาใช้ประโยชน์</span>
            </h2>
          </div>
          <motion.div {...animation(1)} className='content-2'>
            <h2 className='content-2__content--desktop'>
              เราภูมิใจที่ได้เป็นส่วนหนึ่งในการขับเคลื่อนเศรษฐกิจและสังคมด้วย{' '}
              <span>การพัฒนา AI Solution</span>{' '}
              ที่ได้สร้างการเปลี่ยนแปลงที่ดีให้ ธุรกิจไทย{' '}
              <span>แบบครบวงจร</span>
            </h2>
            <h2 className='content-2__content--mobile'>
              เราภูมิใจที่ได้เป็นส่วนหนึ่งในการขับเคลื่อนเศรษฐกิจ{' '}
              <br className='content-2__content--mobile__lineBreak' />
              และสังคมด้วย<span>การพัฒนา AI Solution</span>{' '}
              ที่ได้สร้างการเปลี่ยนแปลงที่ดีให้ ธุรกิจไทย
              <span>แบบครบวงจร</span>
            </h2>
            <picture className='content-2__image'>
              <source
                srcSet='/images/custom-ai/ai-about2.webp'
                type='image/webp'
              />
              <source
                srcSet='/images/custom-ai/ai-about2.png, /images/custom-ai/ai-about2@2x.png'
                type='image/png'
              />
              <img
                src='/images/custom-ai/ai-about2.png'
                alt='Custom AI'
                width='200'
                loading='lazy'
              />
            </picture>
          </motion.div>
        </div>
        <div className='CustomAI__about__container__action'>
          <motion.a
            {...animation(1)}
            href='#contact'
            onClick={(e) => {
              scrollTo(e)
              logEvent({
                ga: {
                  category: 'Custom AI',
                  action: 'Action: Click CTA',
                },
              })
            }}
          >
            ทำความรู้จัก Data Wow <IconArrowRight className='icon' />
          </motion.a>
        </div>
      </div>
    </motion.div>
  )
}
